import script from "./UsersView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersView.vue?vue&type=script&setup=true&lang=ts"

import "./UsersView.vue?vue&type=style&index=0&id=2a7b7b56&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a7b7b56"]])

export default __exports__